import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./marcas.component.html')
})
export class MarcasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/marcas/marcas.component.ts
 **/